module.exports = __webpack_public_path__ + "static/media/i_hu.1c64d267.pdf";